<template>
<van-cell-group title="绑定确认中" inset>
  <p class="textIndentation">
    您的绑定申请已经提交，本次绑定需要3-5个工作日，平台和医疗机构会对您的申请进行确认，请您耐心等待！
  </p>
</van-cell-group>
</template>
<script>
</script>

<style>
.textIndentation{
    font-size: 16px;
    text-align:left;
    text-indent:2em;
  }
</style>
